import { useRouter } from "@tanstack/react-router";
import { useDeletePendingReturn } from "./useDeletePendingReturn";

// Material-ui imports
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";

export const CancelDialog = ({ no, open, handleClose }) => {
  const router = useRouter();
  // Cancel Return
  const { mutate } = useDeletePendingReturn();
  const cancelReturn = () => {
    const deleteReturn = {
      data: {
        filter: { noFilter: no },
      },
    };
    mutate(deleteReturn);
    handleClose();
    router.history.back();
  };

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="cancel-return-dialog-title"
        aria-describedby="cancel-return-dialog-description"
      >
        <DialogTitle id="cancel-return-dialog-title">Cancel Return</DialogTitle>
        <DialogContent>
          <DialogContentText id="cancel-return-dialog-description">
            Are you sure you want to cancel return {no}?
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>No</Button>
          <Button onClick={cancelReturn} autoFocus>
            Yes
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
